import { LayerProps } from "react-map-gl/maplibre";
import { PointQuantityConfigs } from "~map-style-utils/types/__generated/gql/graphql";

export const getPointQuantityStyle = (
	configs: PointQuantityConfigs,
): LayerProps[] => {
	const { symbolStyle, valueField, symbolValues } = configs;

	const styles: LayerProps[] = [];

	if (symbolStyle?.basic?.symbol === "circle") {
		styles.push({
			id: "fill-stroke-circle",
			type: "circle",
			paint: {
				// @ts-ignore
				"circle-color": [
					"step",
					["get", valueField!],
					...symbolValues!.flatMap(({ symbol, min }) => [
						symbol!.fill!.color!,
						min!,
					]),
					"#ffffff",
				],
				"circle-radius": symbolStyle?.basic?.size ?? 8,
				"circle-opacity": symbolStyle?.fill?.opacity ?? 1,
				"circle-stroke-color": symbolStyle?.stroke?.color ?? "#000000",
				"circle-stroke-width": symbolStyle?.stroke?.width ?? 1,
				"circle-stroke-opacity": symbolStyle?.stroke?.opacity ?? 1,
			},
		});
	} else {
		styles.push({
			type: "symbol",
			layout: {
				"icon-overlap": "always",
				"icon-image": `${symbolStyle?.basic?.symbol}-icon`,
				"icon-size": (symbolStyle?.basic?.size ?? 0) / 15,
				"icon-rotate": symbolStyle?.basic?.rotation ?? 0,
			},
			paint: {
				// @ts-ignore
				"icon-color": [
					"step",
					["get", valueField!],
					...symbolValues!.flatMap(({ symbol, min }) => [
						symbol!.fill!.color!,
						min!,
					]),
					"#ffffff",
				],
				"icon-opacity": symbolStyle?.fill?.opacity ?? 1,
			},
		});
	}

	return styles;
};
